module.exports = __webpack_public_path__ + "img/arrow.1b395217.svg";